// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"loaderWrapper__1QlQX","fullScreen":"fullScreen__3lp2A"};